// Auto-generated skeleton for Unit

import { BuildingType } from "./BuildingType";
import { Building } from "./Building";
import { DocumentContainer } from "./DocumentContainer";

export const Unit: Api.Unit = {
  id: 0,
  area: '',
  hp_id: null,
  building_id: 0,
  searchstring: null,
  position: null,
  is_unit: null,
  commercial: null,
  tax: null,
  promoted: null,
  garage: null,
  paid: null,
  bound_till: null,
  mode_of_use: null,
  carport: null,
  part_ownership: null,
  created: null,
  updated: null,
  unit_type: BuildingType,
  building: Building,
  meters_count: 0,
  document_container: DocumentContainer,
};

